import React, { useEffect } from "react"
import { BACKEND_APIS } from "@constants"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useManualExecution } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import FrequencyAutocomplete from "Pages/ReportsAlerts/Reports/@components/Frequency"


export default function ReportFrequencyDaysField() {

	const {
		idFrequencyWhen,
		setIdFrequencyWhenInfo,
		error
	} = useReportFormInfo(reportFormData.peek()?.idFrequencyWhen || [], "idFrequencyWhen", object(!useManualExecution.value ? { idFrequencyWhen: array().required("Must provide at least one day of frequency").min(1, "Must provide at least one day of frequency") } : {}))

	useEffect(() => {
		if (useManualExecution.value) setIdFrequencyWhenInfo([])
	}, [useManualExecution.value])

	return <FrequencyAutocomplete
		disabled={useManualExecution.value}
		value={idFrequencyWhen}
		onChange={e => setIdFrequencyWhenInfo(e.target.value)}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/frequencyV2`}
		error={error}
	/>
}